<template>
  <div class="c-subject-nav">
    <ul class="c-subject-nav__list">
      <li v-if="learningStatus" :class="{'c-subject-nav__list__item':true,'c-subject-nav__list__item--all':true,
          'current':currentTab === 'all'}">
        <a @click="clickSubject('all')" :name="`${name}-総合`">
          <span class="label">総合</span>
        </a>
      </li>
      <li v-for="(subj, i) in licensedSubject" :key="i"
          :class="{'c-subject-nav__list__item':true, ['c-subject-nav__list__item--'+ subjectMap[subj.name]]:true,
          'current': currentTab === subjectFieldMap[subj.field] || currentTabLearningStatus === subjectFieldMap[subj.field]}">
         <a @click="clickSubject(subjectFieldMap[subj.field])" :name="`${name}-${subj.field}`">
          <span class="label">{{subj.field}}</span>
          <span v-if="isRecommendedSubject(subj.field)" class="iconRecom"><span>オススメ</span></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {ref, watch, onMounted} from 'vue';
import {SUBJECT_MAP, SUBJECTFIELD_MAP} from "@/consts/subject";
import { useTopStore } from '@/store/student/top_store';

  const props = withDefaults(
    defineProps<{
      licensedSubject: Array<any>;
      currentMission: string;
      learningStatus?: boolean;
      name?: string;
    }>(),
    {
      learningStatus: false,
      name: '',
    }
  );
  
  const currentTab = ref('all')
  const currentTabLearningStatus = ref('')
  const subjectMap = ref(SUBJECT_MAP)
  const subjectFieldMap = ref(SUBJECTFIELD_MAP)

  const emit = defineEmits<{
    (e: 'click', value: string): void
  }>()

  onMounted(() => {
    if(!props.learningStatus){
      currentTabLearningStatus.value = props.currentMission
    }
  })

  // TOP画面のミッション一覧のカルーセルをクリックして現在のミッションを感知してボタンをactiveにする
  watch(
    () => props.currentMission,
    () => {
      currentTabLearningStatus.value = ""
      currentTab.value = props.currentMission
    }
  )

  function isRecommendedSubject(subject){
    return useTopStore().recommend.some(r => r.name == subject)
  }

  function clickSubject(subject) {
    emit('click', subject)
    currentTabLearningStatus.value = ""
    currentTab.value = subject
  }

</script>
